import * as Simulation from './styles'

const SimulationHeader = () => (
  <Simulation.Header>
    <Simulation.Heading tag="h2">Antecipação Saque-Aniversário</Simulation.Heading>
    <Simulation.Divider aria-hidden />
  </Simulation.Header>
)

export default SimulationHeader
